import { useMemo } from "react";
import { useSlackNotificationSettings } from "@/v2/entities/notifications/SlackNotifications.api";

export function useHitlSlackChannelId() {
  const { data: slackSettings, isLoading, error } = useSlackNotificationSettings();

  const channelId = useMemo(() => {
    const setting = slackSettings?.find(
      (s) => s.trigger === "HITL_APPROVAL_REQUESTED"
    );
    if (!setting?.enabled) return undefined;
    return setting.channelId?.trim() || undefined;
  }, [slackSettings]);

  return { channelId, isLoading, error };
}
